import { useQueryClient } from "@tanstack/react-query"
import { createFileRoute, Outlet, redirect, useRouter } from "@tanstack/react-router"
import { useEffect } from "react"
import Hero from "../components/hero"
import { VersionFooter } from "../components/version-footer"
import { CurrentUserContextProvider } from "../context/useCurrentUserContext"
import { fetchWorkoutsQueryOptions } from "../hooks/useWorkouts"
import { authClient } from "../lib/auth/authClient"

export const Route = createFileRoute("/_app")({
  component: Home,
  beforeLoad: async () => {
    const { data: session } = await authClient.getSession()
    if (!session) {
      throw redirect({ to: "/login" })
    }
  },
})

function Home() {
  const queryClient = useQueryClient()
  const router = useRouter()
  queryClient.prefetchQuery(fetchWorkoutsQueryOptions)

  // Bridge for the Deno Desktop native menu bar: lets the OS menu drive
  // client-side navigation without a full page reload. See apps/web/desktop.ts.
  useEffect(() => {
    window.__openironNavigate = (to: string) => router.navigate({ to: to as never })
    return () => {
      window.__openironNavigate = undefined
    }
  }, [router])

  return (
    <CurrentUserContextProvider>
      <div className="flex min-h-screen flex-col bg-background">
        <Hero />
        <main className="container mx-auto max-w-6xl flex-1 px-3 pb-24 sm:px-4 sm:pb-20 md:p-4">
          <Outlet />
        </main>
        <VersionFooter />
      </div>
    </CurrentUserContextProvider>
  )
}
